// 한국어 번역
export const ko = {
  title: 'HandinCap',
  subtitle: '당신의 스코어카드',
  create: '새 게임 만들기',
  courseTitle: '코스 설정',
  autoMode: '자동 검색',
  manualMode: '수동 입력',
  searchPlaceholder: '코스 이름 검색...',
  selectCourse: '코스 선택',
  gameType: '게임 유형',
  setPar: 'PAR 값 설정',
  confirmCourse: '확인',
  playerTitle: '플레이어 설정',
  players: '플레이어',
  player1: '플레이어 1',
  player2: '플레이어 2',
  player3: '플레이어 3',
  player4: '플레이어 4',
  player5: '플레이어 5',
  player6: '플레이어 6',
  player7: '플레이어 7',
  player8: '플레이어 8',
  enterName: '이름 입력',
  gameMode: '게임 모드',
  matchPlay: '매치 플레이',
  win123: 'Win123',
  skins: '스킨스',
  baccarat: '바카라',
  stake: '베팅',
  prizePool: '상금 풀',
  penaltyPot: '벌금 풀',
  optional: '선택',
  enterStake: '금액 입력 (선택)',
  handicap: '핸디캡',
  handicapSettings: '핸디캡 설정',
  off: '끄기',
  on: '켜기',
  back: '뒤로',
  start: '게임 시작',
  hole: '홀',
  par: 'PAR',
  nextHole: '확인 후 다음',
  currentMoney: '실시간 순위',
  poolBalance: '풀 잔액',
  holeTied: '무승부',
  poolGrows: '다음 홀 풀',
  skinsWinner: '{player}가 스킨 획득!',
  holeSettlement: '홀 정산',
  netScore: '네트',
  rank: '{n}위',
  winner: '승자',
  resume: '게임 계속',
  finishRound: '확인 후 종료',
  kaki: '골프 친구',
  kakiDeleteConfirm: '이 골프 친구를 삭제할까요?',
  confirmHoleScore: '홀 {hole} 스코어 확인',
  holeScoresSummary: '플레이어 스코어:',
  cancel: '취소',
  yes: '예',
  confirm: '확인',
  switchLang: '언어',
  noStake: '베팅 금액을 입력하세요',
  atLeast2: '최소 2명의 플레이어를 입력하세요',
  gameOver: '게임 종료!',
  backToHome: '홈으로 돌아가기',
  out: '아웃',
  in: '인',
  total: '합계',
  totalScore: '총 스코어',
  standardPar: '파',
  finalSettlement: '최종 정산',
  noScoreData: '아직 스코어가 없습니다',
  f9: '전반 9홀',
  b9: '후반 9홀',
  f18: '전반 18홀',
  b18: '후반 18홀',
  f9Desc: '홀 1-9',
  b9Desc: '홀 10-18',
  f18Desc: '표준 1-18',
  b18Desc: '10-18, 1-9',
  duplicateNames: '플레이어 이름은 중복될 수 없습니다',
  screenshotHint: '스크린샷으로 기록을 저장하시기 바랍니다',
  totalLoss: '합계',
  totalPar: 'PAR',
  noCourses: '코스를 찾을 수 없습니다',
  trySearch: '다른 키워드를 시도하세요',
  front9: '전반',
  back9: '후반',
  eagle: '이글',
  birdie: '버디',
  parLabel: '파',
  bogey: '보기',
  doubleplus: '더블보기+',
  selectHoleToEdit: '편집할 홀 선택',
  holeJumpTitle: '홀로 이동',
  holeJumpReturnToast: '{n}개 홀 남음 — {hole}번 홀로 돌아갑니다',
  editHole: '편집',
  save: '저장',
  scoreUpdated: '스코어 업데이트 완료, 금액 재계산 완료',
  matchPlayDesc: '최저 네트 스코어 승리, 패자가 베팅금 지불',
  win123Desc: '순위별 벌금, UP으로 리스크/보상',
  skinsDesc: '모두 참여, 단독 최저타만 전액 획득',
  baccaratDesc: '1대1 대결, UP으로 베팅 배수',
  reportTitle: ' 리포트',
  scoreDistribution: '스코어 분포',
  puttingAnalysis: '퍼팅 분석',
  totalPutts: '총 퍼팅',
  avgPerHole: '평균/홀',
  onePutt: '원퍼팅',
  threePutts: '3퍼팅 이상',
  holes: '홀',
  penaltyStats: '페널티 통계',
  waterHazard: '워터',
  stats: ' 통계',
  attempts: '회',
  times: '',
  holeByHole: '홀별 스코어',
  viewFullDetail: '전체 보기',
  fullDetail: '전체 상세',
  strokes: '타',
  putt: '퍼팅',
  water: '워터',
  clickNameToView: '이름을 탭하여 상세 보기',
  confirmPutts: '퍼팅 수 확인',
  zeroPuttsWarning: '다음 플레이어의 퍼팅 수가 0입니다:',
  puttsScore: '스코어',
  puttsStrokes: '',
  puttsPutts: '퍼팅',
  puttsTip: '팁: 칩인이 아니라면 퍼팅 수는 보통 0이 아닙니다',
  puttsGoBack: '돌아가기',
  puttsConfirm: '확인',
  mpMultiplayer: '멀티플레이어',
  mpSync: '멀티플레이어 동기화',
  mpCodePlaceholder: '코드',
  mpEnter6Digit: '4자리 코드 입력',
  mpJoin: '참가',
  mpPointQr: 'QR 코드를 향하세요',
  mpQrLoadFail: 'QR 라이브러리 로드 실패',
  mpLinkCopied: '링크 복사됨!',
  mpCopyLink: '링크 복사',
  mpShareLink: '공유',
  startSolo: '솔로 시작',
  mpJumbo: '점보',
  mpCreateRoom: '방 만들기',
  mpWaitingPartner: '파트너 대기 중',
  mpWaitingStart: '시작 대기 중',
  mpRoomCode: '방 코드',
  mpCopied: '복사됨!',
  mpCopyCode: '코드 복사',
  mpScanToJoin: '스캔하여 참가',
  mpGameInfo: '게임 정보',
  mpCourse: '코스',
  mpMode: '모드',
  mpStake: '베팅',
  mpRoom: '방',
  mpPlayerAssignment: '플레이어 배정',
  mpMine: '내 것',
  mpPartner: '상대',
  mpUnclaimed: '미배정',
  mpConnected: '연결됨',
  mpError: '오류',
  mpConnecting: '연결 중...',
  mpStartGame: '게임 시작',
  mpWaitingCreator: '생성자가 게임을 시작할 때까지 대기 중...',
  mpClaimTitle: '플레이어 선택',
  mpClaimDesc: '스코어를 입력할 플레이어를 선택하세요',
  mpSelectOne: '최소 한 명을 선택하세요',
  mpConfirmClaim: '선택 확인',
  mpConfirmSubmit: '확인',
  mpWaiting: '대기 중...',
  mpConfirmFinish: '확인 후 종료',
  mpConfirmNext: '확인 후 다음',
  mpAdvancedStats: '고급 통계 모드',
  mpHolesLabel: '홀',
  hcpLabel: 'HCP',
  hideInfo: '닫기',
  learnMore: '자세히 보기',
  close: '닫기',
  clearRecent: '삭제',
  recentCourses: '최근 코스',
  endGame: '종료',
  shareRoundReport: '라운드 리포트 공유',
  allDataCleared: '모든 게임 데이터가 삭제됩니다',
  endGameConfirm: '게임을 종료하시겠습니까?\n미완료 홀은 집계되지 않습니다',
  holeLabel: '홀 {n}',
  holeLabelShort: 'H{n}',
  cameraAccessDenied: '카메라 접근이 거부되었습니다',
  generateLinkFailed: '링크 생성 실패',
  copyFailed: '복사 실패',
  retracted: '철회되었습니다. 스코어를 수정할 수 있습니다.',
  matchPlayBubble: '각 홀 최저 네트가 승리. 무승부? 지불 없음.',
  win123Bubble: '네트 스코어로 순위. 순위 낮을수록 벌금 큼. UP으로 리스크/보상.',
  skinsBubble: '단독 최저 스코어만 풀 획득. 무승부? 다음 홀로 이월.',
  baccaratBubble: '4명 6조 대결. UP으로 베팅 올리기.',
  mpSyncBubble: '내 플레이어는 내가, 상대는 상대가 스코어 입력. 자동 동기화.',
  hcpBubble: '핸디캡 (0-36): 다른 실력의 플레이어가 공정하게 경쟁. 코스 난이도에 따라 스트로크가 자동 배분됩니다.',
  undoEdit: '취소 및 수정',
  waitingProceed: '{badge} 진행 대기 중...',
  voiceWithHcp: '{player}, {on} 온, {putt} 퍼팅, 핸디캡 {handicap}.',
  voiceNoHcp: '{player}, {on} 온, {putt} 퍼팅.',
  voiceHoleIntro: '홀 {hole}, 파 {par}, 인덱스 {index}.',
  voiceHoleIntroNoIdx: '홀 {hole}, 파 {par}.',
  voiceHcpOnHole: '{player}, 핸디캡 {strokes} 스트로크',
  ttsLang: 'ko-KR',
  editLogTitle: '수정 기록',
  editLogHoleTitle: '홀 {n} 수정 기록',
  editLogEmpty: '수정 기록 없음',
  editLogCount: '{n}건 수정',
  editLogAllRecorded: '모든 편집이 기록되었습니다',
  editLogScore: '스코어',
  editLogPutts: '퍼팅',
  editLogUp: 'UP',
  editNotifyTitle: '홀 {n} 스코어 수정됨',
  editNotifyBy: '{who}이(가) 수정',
  editNotifyDetail: '탭하여 상세 보기',
  editLogTapHint: '홀 번호를 탭하여 수정 기록 보기',
  editLogClose: '닫기',
  // Viewer Mode 관전 모드
  mpRoleTitle: '방 참가',
  mpRoleDesc: '참가 방법 선택',
  mpPlayerRole: '플레이어',
  mpPlayerRoleDesc: '선수 선택 및 스코어 입력',
  mpPlayerTagInput: '스코어 입력',
  mpPlayerTagClaim: '선수 선택',
  mpViewerRole: '관전',
  mpViewerRoleDesc: '실시간 관전 (읽기 전용)',
  mpViewerTagLive: '실시간 스코어',
  mpViewerTagNoInput: '입력 불가',
  mpViewerBanner: '관전 전용 — 스코어 입력 비활성화',
  mpViewerReminder: '이 게임을 관전 중입니다',
  mpViewerReminderDesc: '스코어가 실시간 업데이트됩니다. 입력이나 수정은 불가합니다.',
  exit: '나가기',
  // Scorecard Section
  scorecardHorizontal: '가로',
  scorecardVertical: '세로',
  shareBtn: '공유',
  penalties: '페널티',
  // Feedback 피드백
  feedbackBtn: '피드백',
  feedbackTitle: '피드백',
  feedbackSubtitle: 'HandinCap 개선에 도움을 주세요',
  feedbackRateLabel: '경험 평가',
  feedbackCatLabel: '개선이 필요한 부분은? (복수 선택 가능)',
  feedbackCatNewModes: '새 게임 모드',
  feedbackCatUI: 'UI / 레이아웃',
  feedbackCatSpeed: '성능',
  feedbackCatCourse: '코스 데이터',
  feedbackCatScoring: '스코어링',
  feedbackCatMultiplayer: '멀티플레이어',
  feedbackCatBug: '버그 신고',
  feedbackCatOther: '기타',
  feedbackCommentPlaceholder: '의견을 알려주세요...\n예: Nassau 모드 추가 희망',
  feedbackSubmit: '피드백 보내기',
  feedbackSubmitting: '전송 중...',
  feedbackThanks: '감사합니다!',
  feedbackThanksDetail: '모든 피드백을 확인합니다',
  feedbackSkip: '나중에',
  feedbackStar1: '나쁨',
  feedbackStar2: '보통',
  feedbackStar3: '괜찮음',
  feedbackStar4: '좋음',
  feedbackStar5: '최고!',
  // Share page
  shareInvalidLink: '잘못된 링크',
  shareInvalidDesc: '이 공유 링크는 유효하지 않거나 만료되었습니다.',
  shareGoTo: 'HandinCap으로 이동',
  poweredBy: 'Powered by',
  onLabel: '온',
  avg: '평균',
  totalLabel: '합계',
  // Multiplayer extras
  mpConnectionStatus: '연결 상태',
  mpPlayersJoined: '참가한 플레이어',
  mpViewersJoined: '참가한 관전자',
  mpNoPlayersYet: '아직 참가한 플레이어가 없습니다. 시작할 수 있습니다 — 모든 플레이어의 스코어를 직접 입력합니다.',
  mpProcessing: '처리 중...',
  mpClaimed: '배정됨',
  mpNoPlayers: '플레이어 없음',
  ob: 'OB',
  allConfirmed: '전체 확인됨',
  liveSyncing: '실시간 동기화',
  justNow: '방금',
  minsAgo: '{n}분 전',
  hrsAgo: '{n}시간 전',
  roomNotFound: '방을 찾을 수 없습니다',
  // Round Report
  rrTitle: '라운드 리포트',
  rrGolfCourse: '골프 코스',
  rrTotalScorePar: '총 스코어 (Par: {n})',
  rrShareImage: '이미지 공유',
  rrShareLink: '링크 공유',
  rrImageDownloaded: '이미지 다운로드 완료',
  rrImageFailed: '이미지 생성 실패',
  rrScreenshotFailed: '캡처 실패, 수동으로 스크린샷을 찍어주세요',
  rrOpenApp: 'HandinCap 열기',
  loading: '로딩 중...',
};

export default ko;
